import React from 'react';
import TeamLogo from 'components/molecules/team-logo';
import LockedPlayerGameMarker from 'components/molecules/locked-player-game-marker';
import {LineupPlayers as BaseLineupPlayers} from '../lineup-players';
import {round} from 'helpers/number-helper';
import Const from 'constants';

class LineupPlayers extends BaseLineupPlayers {
    getTableHead() {
        return (
            <tr>
                <th className="td-pos">Pos</th>
                <th />
                <th>Name</th>
                <th className="td-team">Team</th>
                <th className="td-salary">Salary</th>
                <th className="td-fpts">Fpts</th>
                <th className="td-pown">pOwn%</th>
            </tr>
        );
    }

    getTableBody() {
        const {lineupPlayers} = this.props;

        return lineupPlayers.map((player) => {
            return (
                <tr key={player.playerId}>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <LockedPlayerGameMarker player={player} />
                    </td>
                    <td>
                        <strong className="player-name">{player.name}</strong>
                    </td>
                    <td className="td-team">
                        <TeamLogo teamName={player.team} />
                    </td>
                    <td>{player.salary}</td>
                    <td>{round(player.lineupPoints, Const.POINTS_DECIMAL_PRECISION)}</td>
                    <td>{player.projOwn.getValue()}%</td>
                </tr>
            );
        });
    }
}

export {LineupPlayers};
